import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import '../Css/Colleges_Ethiccraft.css';
import API_BASE_URL from '../../api/config';

const RecentEvents = ({ collegeName }) => {
  const [events, setEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/college_events/read_isShown`);
        const arr = Array.isArray(res.data) ? res.data : (res.data.data || []);
        const filteredEvents = arr.filter(
          (event) =>
            event.college?.toLowerCase() === collegeName.toLowerCase()
        );
        setEvents(filteredEvents);
      } catch (error) {
        console.error("Failed to fetch events:", error);
      }
    };

    fetchEvents();
  }, [collegeName]);

  if (events.length === 0) return null;

  return (
    <div className="events-wrapper">
      <h2 className="testimonial-header">Recent Activities</h2>
      <div className="events-scroll">
        {events.map((event, index) => {
          const [day, month, year] = formatDate(event.date);
          return (
            <div key={index} className="event-card" >
              <div className="event-date">
                <span className="month">{month}</span>
                <span className="day">{day},</span>
                <span className="year">{year}</span>  
              </div>
              <img
                src={`https://ethiccraft.org/${event.image}`}
                alt="Event"
                className="event-img"
              />
              <div className="event-details">
                <h3>{event.name}</h3>
                <p className="address">{event.venue}</p>
                <p className="desc">
                  {event.description.length > 250
                    ? event.description.slice(0, 250) + "..."
                    : event.description}
                </p>
                <motion.button
                  className="like-btn11"
                  onClick={() => {
                    setSelectedEvent(event);
                    setShowModal(true);
                  }}
                >
                  Read More
                </motion.button>
              </div>
            </div>
          );
        })}
      </div>

      {showModal && selectedEvent && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            
            {/* Close Button */}
            <button className="modal-close-btn" onClick={() => setShowModal(false)}>
              &times;
            </button>

            {/* Content */}
            <div className="modal-header-section22">
              <img
                className="modal-image22"
                src={`https://ethiccraft.org/${selectedEvent.image}`}
                alt="Event"
                style={{ width: "100%", borderRadius: "10px", marginBottom: "15px" }}
              />
              <div className="modal-text-info22">
                <h3 className="modal-event-name">{selectedEvent.name}</h3>
                <p><strong>Date:</strong> {selectedEvent.date}</p>
                <p><strong>Venue:</strong> {selectedEvent.venue}</p>
                <p className="modal-desc22">{selectedEvent.description}</p>
              </div>
            </div>
            {/* <p><strong>College:</strong> {selectedEvent.college}</p> */}
          </div>
        </div>
      )}
    </div>
  );
};

// Utility to format date string as [day, month]
function formatDate(dateStr) {
  const date = new Date(dateStr);
  const day = String(date.getDate()).padStart(2, "0");
  const month = date.toLocaleString("en-US", { month: "short" }).toUpperCase();
  const year = date.getFullYear();
  return [day, month, year];
}

export default RecentEvents;